import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Outlet, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import WhatsAppWidget from "../WhatsAppWidget";
import AnnouncementModal from "../AnnouncementModal";

function GAListener() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);

  return null;
}

function Layout() {
  return (
    <>
      <AnnouncementModal />
      <div className="layout">
        <GAListener />
        <WhatsAppWidget />
        <Header />
        <div className="home-template">
          <Outlet />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Layout;
